import { FunctionComponent } from 'react'
import { css } from '@emotion/css'
import Big from 'big.js'
import { useTranslation } from 'react-i18next'
import { OrderItemDiscount } from '@/libs/helpers/apiClient'
import { Text } from '@/tbui'
import { palette } from '@/tbui/DefaultThemeProvider/defaultTheme'

const discountDetailStyles = css`
  color: ${palette.DISCOUNT};
  :not(:last-child) {
    margin-bottom: 8px;
  }
`

export const ItemDiscounts: FunctionComponent<{
  itemTotal: string
  orderItemDiscounts: OrderItemDiscount[]
  index: number
  className?: string
}> = ({ itemTotal, orderItemDiscounts, index, className }) => {
  const { t } = useTranslation()

  let leftoverSubtotal = Big(itemTotal)
  return (
    <div className={className}>
      {orderItemDiscounts.map((order, i) => {
        const element = (
          <Text
            key={`${order.discountId}-${i}-${index}`}
            bold
            data-test={`discount-${order.discountId}`}
            className={discountDetailStyles}
          >
            {`${t('currency', { value: Number(leftoverSubtotal).toFixed(2) })} - ${t('currency', {
              value: Number(order.total).toFixed(2),
            })}`}{' '}
            {order.applyType === 'PROMO'
              ? t('cart_widget.item.promo', { value: order.label })
              : order.label}
          </Text>
        )
        leftoverSubtotal = leftoverSubtotal.sub(order.total)
        if (leftoverSubtotal.lt(0)) {
          leftoverSubtotal = Big(0)
        }
        return element
      })}
    </div>
  )
}
